import genericStore from "../generic_store";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "commissions",
    object: "commission",
    header: [
      { text: "Commission", value: "commission_percentage" },
      { text: "Acciones", value: "actions", sortable: false }
    ]
  },
  mutations: {
    ...genericStore.mutations
  },
  actions: {
    ...genericStore.actions
  },
  getters: {
    ...genericStore.getters
  }
};
